import { DEBUG } from "@kikoff/client-utils/src/general";
import { isClient } from "@kikoff/utils/src/general";

if (!DEBUG && isClient) {
  console.log = () => {}; // eslint-disable-line no-console
}
